import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

// Hover help for date labels. Same pattern as the vendor portal's InfoLabel.
export const DATE_HELP = Object.freeze({
    // Supplier flow: the supplier ships to the finisher, not to the customer.
    supplierDispatch: 'The date the supplier plans to ship this order to the finisher.',
    supplierDelivery: 'The date the supplier expects the shipment to arrive at the finisher.',
    supplierDelivered: 'The date the delivery at the finisher was confirmed.',
})

// Label with an info icon that shows the help text on hover.
const InfoLabel = ({ label, info }) => (
    <Tooltip title={info}>
        <span>{label} <InfoCircleOutlined /></span>
    </Tooltip>
)

InfoLabel.propTypes = {
    label: PropTypes.node.isRequired,
    info: PropTypes.node.isRequired,
}

export default InfoLabel
